/* ----------------------------------------------------------------------------
   FEATURED COLLECTIONS V2 — Iris
   Custom element <iris-fc2-arrows> qui cible dynamiquement le scroll-carousel
   du slot actif (changements d'onglet via featured-collections-carousel).
---------------------------------------------------------------------------- */

(function () {
  if (window.customElements.get('iris-fc2-arrows')) return;

  class IrisFc2Arrows extends HTMLElement {
    connectedCallback() {
      const wrapperId = this.getAttribute('for');
      this.wrapper = document.getElementById(wrapperId);
      if (!this.wrapper) return;

      this.prevBtn = this.querySelector('[data-direction="previous"]');
      this.nextBtn = this.querySelector('[data-direction="next"]');
      this._edgeHandlerNearing = null;
      this._edgeHandlerLeaving = null;
      this._currentCarousel = null;

      this.prevBtn.addEventListener('click', () => this._scroll('previous'));
      this.nextBtn.addEventListener('click', () => this._scroll('next'));

      this._bindActive();

      const mo = new MutationObserver(() => this._bindActive());
      this.wrapper
        .querySelectorAll('.featured-collections-carousel__item')
        .forEach((slot) => {
          mo.observe(slot, { attributes: true, attributeFilter: ['class'] });
        });
      this._mo = mo;
    }

    disconnectedCallback() {
      if (this._mo) this._mo.disconnect();
      this._detachEdge();
    }

    _getActiveCarousel() {
      const activeSlot = this.wrapper.querySelector(
        '.featured-collections-carousel__item.is-selected'
      );
      if (!activeSlot) return null;
      return activeSlot.querySelector('scroll-carousel');
    }

    _scroll(direction) {
      const c = this._getActiveCarousel();
      if (!c) return;
      if (direction === 'previous' && typeof c.previous === 'function') c.previous();
      if (direction === 'next' && typeof c.next === 'function') c.next();
    }

    _bindActive() {
      const c = this._getActiveCarousel();
      if (!c || c === this._currentCarousel) return;

      this._detachEdge();

      this.prevBtn.disabled = true;
      this.nextBtn.disabled = false;

      this._currentCarousel = c;
      this._edgeHandlerNearing = (event) => {
        if (event.detail.position === 'start') this.prevBtn.disabled = true;
        if (event.detail.position === 'end') this.nextBtn.disabled = true;
      };
      this._edgeHandlerLeaving = (event) => {
        if (event.detail.position === 'start') this.prevBtn.disabled = false;
        if (event.detail.position === 'end') this.nextBtn.disabled = false;
      };
      c.addEventListener('scroll:edge-nearing', this._edgeHandlerNearing);
      c.addEventListener('scroll:edge-leaving', this._edgeHandlerLeaving);
    }

    _detachEdge() {
      if (this._currentCarousel && this._edgeHandlerNearing) {
        this._currentCarousel.removeEventListener(
          'scroll:edge-nearing',
          this._edgeHandlerNearing
        );
      }
      if (this._currentCarousel && this._edgeHandlerLeaving) {
        this._currentCarousel.removeEventListener(
          'scroll:edge-leaving',
          this._edgeHandlerLeaving
        );
      }
      this._currentCarousel = null;
      this._edgeHandlerNearing = null;
      this._edgeHandlerLeaving = null;
    }
  }

  window.customElements.define('iris-fc2-arrows', IrisFc2Arrows);
})();
